function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import { Popover, PopoverBody, PopoverHeader } from 'reactstrap';
import FontAwesome from 'react-fontawesome';
import styled from 'styled-components';
import OverlayTrigger from '../elements/OverlayTrigger';
var defaultProps = {
  placement: 'top'
};
var Abbr = styled.abbr.withConfig({
  displayName: "HelpPopover__Abbr",
  componentId: "sc-19kvei6-0"
})(["border-bottom:1px dotted;color:#737373;cursor:help;.fa{display:inline;height:auto;margin:0 2px;vertical-align:unset;width:auto;}"]); // Component to display a help popover for contained text when this is clicked.

var HelpPopover = function HelpPopover(_ref) {
  var children = _ref.children,
      className = _ref.className,
      content = _ref.content,
      placement = _ref.placement,
      title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["children", "className", "content", "placement", "title"]);

  var popover = /*#__PURE__*/React.createElement(Popover, _extends({
    placement: placement // target will be set correctly by OverlayTrigger.  Only included to
    // prevent proptype warnings.
    ,
    target: ""
  }, rest), title ? /*#__PURE__*/React.createElement(PopoverHeader, null, title) : null, /*#__PURE__*/React.createElement(PopoverBody, null, content));
  return /*#__PURE__*/React.createElement(OverlayTrigger, {
    className: className,
    overlay: popover,
    trigger: "click"
  }, /*#__PURE__*/React.createElement(Abbr, null, children, /*#__PURE__*/React.createElement(FontAwesome, {
    name: "question-circle"
  })));
};

HelpPopover.defaultProps = defaultProps;
export default HelpPopover;